import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface groupManagementInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: groupManagementInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const GroupManagementSlice = createSlice({
  name: 'groupManagementSlice',
  initialState,
  reducers: {
    setGroupManagementMeta: (
      state,
      action: PayloadAction<{
        meta: { totalRecords: number | string; totalPages: number | string };
      }>
    ) => {
      state.totalRecords = Number(action.payload.meta.totalRecords);
      state.totalPages = Number(action.payload.meta.totalPages);
    }
  }
});
